const STORAGE_KEY = 'kiosk_client_version';

export function readClientVersion(): number | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null || raw === '') return null;
    const version = Number(raw);
    if (!Number.isSafeInteger(version) || version < 0) return null;
    return version;
  } catch {
    return null;
  }
}

export function writeClientVersion(version: number): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, String(version));
  } catch {
    /* quota / private mode */
  }
}

/**
 * What to do once the public version API has answered.
 * No API number: hide the dialog and write nothing.
 * No saved number: save the API number and stay quiet.
 * A newer API number shows the dialog, then the saved number is updated to the API number.
 */
export function nextClientVersionState(stored: number | null, remote: number | null): {
  show: boolean;
  persist: number | null;
} {
  if (remote == null) return { show: false, persist: null };
  return {
    show: stored != null && remote > stored,
    persist: remote,
  };
}
